import React from 'react';

interface IDefaultAvatar {
  children?: any;
  size?: number;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
}

const DefaultAvatar: React.FC<IDefaultAvatar> = ({ children, size, bgColor, textColor, borderColor }) => (
  <div
    className='avatar-circle'
    style={{
      width: size,
      height: size,
      background: bgColor,
      color: textColor,
      border: borderColor ? `1px solid ${borderColor}` : undefined,
    }}>
    {children && <div style={{ fontSize: size ? size - 5 : undefined }}>{children}</div>}
  </div>
);

export default DefaultAvatar;
